import React, { createContext, useContext, useEffect, useState } from "react";

const CustomerSegmentContext = createContext(null);

export const CustomerSegmentProvider = ({ children }) => {
  const [segment, setSegment] = useState(() => {
    if (typeof window === "undefined") return "private";
    const stored = window.localStorage.getItem("sf_segment");
    return stored === "commercial" ? "commercial" : "private";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem("sf_segment", segment);
      document.documentElement.setAttribute("data-segment", segment);
    }
  }, [segment]);

  const value = { segment, setSegment, isPrivate: segment === "private", isCommercial: segment === "commercial" };
  return <CustomerSegmentContext.Provider value={value}>{children}</CustomerSegmentContext.Provider>;
};

export const useSegment = () => {
  const ctx = useContext(CustomerSegmentContext);
  if (!ctx) throw new Error("useSegment must be used within CustomerSegmentProvider");
  return ctx;
};
